<template>
<div class="chapter">
<div class="inner_page">
<h2 id="pgepubid00010">Contents</h2>
<table cellpadding="1" cellspacing="0" class="calibre5" summary="Table of Contents">
<tbody class="calibre6">
<tr class="calibre7">
<td class="calibre8">I.</td>
<td class="calibre9"><em class="smcap">Into the Woods</em></td>
<td class="calibre8"><a href="#/Text/Section0004">9</a></td>
</tr>
<tr class="calibre7">
<td class="calibre8">II.</td>
<td class="calibre9"><em class="smcap">Mr. Croyden Keeps His Promise</em></td>
<td class="calibre8"><a href="#/Text/Section0005">31</a></td>
</tr>
<tr class="calibre7">
<td class="calibre8">III.</td>
<td class="calibre9"><em class="smcap">Theo Meets with a Calamity</em></td>
<td class="calibre8"><span href="#/Text/Section0006" title="Link target outside of Sample">47</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">IV.</td>
<td class="calibre9"><em class="smcap">Mr. Croyden's Story</em></td>
<td class="calibre8"><span href="#/Text/Section0007" title="Link target outside of Sample">60</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">V.</td>
<td class="calibre9"><em class="smcap">The Potter Who Burned His Chairs</em></td>
<td class="calibre8"><span href="#/Text/Section0008" title="Link target outside of Sample">80</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">VI.</td>
<td class="calibre9"><em class="smcap">From Vases to Drain-Pipes</em></td>
<td class="calibre8"><span href="#/Text/Section0009" title="Link target outside of Sample">98</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">VII.</td>
<td class="calibre9"><em class="smcap">Porcelain at Last</em></td>
<td class="calibre8"><span href="#/Text/Section0010" title="Link target outside of Sample">111</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">VIII.</td>
<td class="calibre9"><em class="smcap">The Third Famous Potter</em></td>
<td class="calibre8"><span href="#/Text/Section0011" title="Link target outside of Sample">129</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">IX.</td>
<td class="calibre9"><em class="smcap">The Romance of French China-Making</em></td>
<td class="calibre8"><span href="#/Text/Section0012" title="Link target outside of Sample">149</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">X.</td>
<td class="calibre9"><em class="smcap">How the Italians Made China</em></td>
<td class="calibre8"><span href="#/Text/Section0013" title="Link target outside of Sample">160</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XI.</td>
<td class="calibre9"><em class="smcap">Our English Cousins</em></td>
<td class="calibre8"><span href="#/Text/Section0014" title="Link target outside of Sample">173</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XII.</td>
<td class="calibre9"><em class="smcap">Theo Makes a Present</em></td>
<td class="calibre8"><span href="#/Text/Section0015" title="Link target outside of Sample">193</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XIII.</td>
<td class="calibre9"><em class="smcap">The Trenton Visit</em></td>
<td class="calibre8"><span href="#/Text/Section0016" title="Link target outside of Sample">210</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XIV.</td>
<td class="calibre9"><em class="smcap">The Beginning of the Porcelain Pilgrimage</em></td>
<td class="calibre8"><span href="#/Text/Section0017" title="Link target outside of Sample">223</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XV.</td>
<td class="calibre9"><em class="smcap">How Porcelain is Made</em></td>
<td class="calibre8"><span href="#/Text/Section0018" title="Link target outside of Sample">235</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XVI.</td>
<td class="calibre9"><em class="smcap">Dishes, Dishes Everywhere!</em></td>
<td class="calibre8"><span href="#/Text/Section0019" title="Link target outside of Sample">246</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XVII.</td>
<td class="calibre9"><em class="smcap">The Decoration of China</em></td>
<td class="calibre8"><span href="#/Text/Section0020" title="Link target outside of Sample">260</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XVIII.</td>
<td class="calibre9"><em class="smcap">Theo's Great Choice</em></td>
<td class="calibre8"><span href="#/Text/Section0021" title="Link target outside of Sample">281</span></td>
</tr>
</tbody>
</table>
<p><br/></p>
<div class="calibre1">
<a id="png007"></a> <a id="png008"></a>
</div>
<div class="calibre1">
<a id="png009"></a> <a id="png010"></a>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?8679eba4